import { render, staticRenderFns } from "./MenuObservacao.vue?vue&type=template&id=e3388df0"
import script from "./MenuObservacao.vue?vue&type=script&lang=js"
export * from "./MenuObservacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports